// @flow

import React, { type Node } from 'react';
import { getPaymentTypeCode, useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import { ArgentineCashContent } from '../argentine-cash/page-content';
import { PagofacilPage } from '../pagofacil/pagofacil-page';
import { OxxoPage } from '../oxxo-page/oxxo-page';
import { PagoEfectivoPage } from '../pagoefectivo-page/page-content';
import { PagosNetPage } from '../pagosnet-page/pagosnet-page';
import { MpesaPage } from '../mpesa-page/mpesa-page';
import { UssdPage } from '../ussd-page/ussd-page';
import { PuntoXpressPage } from '../puntoxpress-page/puntoxpress-page';
import { DebinPage } from '../debin-page/debin-page';
import { CellulantPage } from '../cellulant-page/cellulant-page';
import { CashfreeUpiQrcodePage } from '../cashfree-upi-qrcode-page/cashfree-upi-qrcode-page';
import { CashfreeUpiCollectPage } from '../cashfree-upi-collect-page/cashfree-upi-collect-page';
import { UpiIntentPage } from '../upi-intent-page/upi-intent-page';
import { RedirectPageContent } from '@tectonics/look-and-feel/shopify/pages/pending-payment/redirect';
import { FawryPage } from '../fawry/fawry-page';
import { OpayPage } from '../opay/opay-page';

export function ShowPendingPageContent(): Node {
  const incomingPayment = useIncomingPayment();
  const paymentTypeCode = getPaymentTypeCode(incomingPayment) || 'null';
  const country = getCountry(incomingPayment);
  switch (paymentTypeCode) {
    case 'pagofacil':
      return <PagofacilPage />;
    case 'rapipago':
      return <ArgentineCashContent />;
    case 'oxxo':
    case 'oxxopay':
      return <OxxoPage paymentTypeCode={paymentTypeCode} />;
    case 'pagosnet':
      return <PagosNetPage />;
    case 'pagoefectivo':
      return <PagoEfectivoPage />;
    case 'mpesa':
      return <MpesaPage />;
    case 'ussd':
      return <UssdPage />;
    case 'puntoxpress':
      return <PuntoXpressPage />;
    case 'debin':
      return <DebinPage />;
    case 'equitel':
    case 'airtel':
    case 'tigo':
    case 'vodacom':
    case 'mtn':
    case 'zamtel':
      return <CellulantPage />;
    case 'upi-qrcode':
      return <CashfreeUpiQrcodePage />;
    case 'upi-collect':
      return <CashfreeUpiCollectPage />;
    case 'upi-intent':
      return <UpiIntentPage />;
    case 'nibbs':
      return <RedirectPageContent/>;
    case 'fawry-external':
      return <FawryPage />;
    case 'opay':
      return <OpayPage />;

    default:
      throw new Error(`PendingPage for ${paymentTypeCode} is not implemented in ${country}`);
  }
}
